export default __webpack_public_path__ + "static/media/lock.69d21b0d.svg";